import { ApiClient } from "@/api";

const stateInit = {
  destination: {
    name: "",
    image_detail: "",
  },
  sort: {
    key: "id",
    reverse: false,
    options: {
      id: (a, b) => a - b,
      ship: (a, b) => a.name.localeCompare(b.name),
      min_price: (a, b) => a - b,
      discount: (a, b) => a - b,
      days: (a, b) => a - b,
      years: (a, b) => a - b,
      date_from: (a, b) => a - b,
      date_to: (a, b) => a - b,
    },
  },
  options: {
    view: "table",
    page: 1,
    last_page: 1,
    total: 0,
    load: false,
  },
  items: [],
};

export default new window.mainVuex.Store({
  state: stateInit,
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    addItems(state, items) {
      state.items.push(...items);
    },
    setLoad(state, value) {
      state.options.load = value;
    },
    sortItems(state, data) {
      let key = data.key,
        reverse = data.reverse;
      const { sort } = state;
      if (sort.options[key]) {
        sort.reverse = reverse ?? false;
        sort.key = key;
        const compare = sort.options[key];
        state.items.sort(
          (a, b) => compare(a[key], b[key]) * (reverse ? -1 : 1)
        );
      }
    },
    addPage(state, page) {
      state.options.page = state.options.page + page;
    },
    setPage(state, page) {
      state.options.page = page;
    },
    setLastPage(state, page) {
      state.options.last_page = page;
    },
    setTotal(state, data) {
      state.options.total = data;
    },
  },
  getters: {
    destination: (state) => {
      return state.destination;
    },
    options: (state) => {
      return state.options;
    },
    items: (state) => {
      return state.items;
    },
    sort: (state) => {
      return state.sort;
    },
  },
  actions: {
    async getList(context, data) {
      const filter = data.filter;
      const addItems = data.addItems;
      context.commit("setLoad", true);
      const options = context.getters.options;
      await ApiClient.get(`/api/v3/cruises/?page=${options.page}& `+ filter).then(function (
        response
      ) {
        context.commit("setLoad", false);
        context.commit(addItems ? "addItems" : "setItems", response.data);
        context.commit("setPage", response.pagination.current_page);
        context.commit("setLastPage", response.pagination.last_page);
        context.commit("setTotal", response.pagination.total);
      });
    },
    setSort(context, data) {
      context.commit("sortItems", data);
    },
  },
  strict: true,
});
